import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useCustomizationOptions } from '../hooks/useCustomizationOptions';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { PdpRespSidebarDetailsSection } from './PdpRespSidebarDetailsSection';
import { PdpSharedDescriptionAdditionalOptionsContent } from '../PdpSharedDescriptions/PdpSharedDescriptionAdditionalOptionsContent';

// types
import { type PdpRespSidebarDetailsCustomization_item$key as Item } from './__generated__/PdpRespSidebarDetailsCustomization_item.graphql';
import { type PdpRespSidebarDetailsCustomization_user$key as User } from './__generated__/PdpRespSidebarDetailsCustomization_user.graphql';

const Customization = (
    <FormattedMessage
        id="PdpRespSidebarDetailsCustomization.customization"
        defaultMessage="Customization"
    />
);

const userFragment = graphql`
    fragment PdpRespSidebarDetailsCustomization_user on User {
        ...PdpSharedDescriptionAdditionalOptionsContent_user
    }
`;

const itemFragment = graphql`
    fragment PdpRespSidebarDetailsCustomization_item on Item {
        isCustomizable
        isDyoCustomizable
        ...useCustomizationOptions_item
        ...PdpSharedDescriptionAdditionalOptionsContent_item
    }
`;
export const PdpRespSidebarDetailsCustomization: FC<{ item: Item; user: User | null }> = ({
    item: itemRef,
    user: userRef,
}) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const { customizationOptions, isResizable } = useCustomizationOptions({ item });

    const { isCustomizable = null, isDyoCustomizable } = item || {};

    if (!(isCustomizable && !!customizationOptions) && !isDyoCustomizable && !isResizable) {
        return null;
    }

    return (
        <PdpRespSidebarDetailsSection title={Customization} ga={{ trigger: 'customization' }}>
            <PdpSharedDescriptionAdditionalOptionsContent
                item={item}
                user={user}
                disableExpansion
                buttonSize="medium"
                isResizable={isResizable}
                isDyoCustomizable={isDyoCustomizable}
                customizationOptions={customizationOptions}
            />
        </PdpRespSidebarDetailsSection>
    );
};
